module.exports = __webpack_public_path__ + "static/media/sf-test-11.d6029810.mp3";